/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
/**
 * These modules are bundled with Abc-Map web application.
 *
 * Values of enum are used in webapp URLs.
 */
export var ModuleId;
(function (ModuleId) {
    ModuleId["ArtefactGenerator"] = "artefact-generator";
    ModuleId["ColorGradients"] = "color-gradients";
    ModuleId["CountPointsInPolygon"] = "count-points-in-polygon";
    ModuleId["DataStore"] = "data-store";
    ModuleId["DataTable"] = "data-table";
    ModuleId["DifferentSymbols"] = "different-symbols";
    ModuleId["ProjectManagement"] = "project-management";
    ModuleId["ProportionalSymbols"] = "proportional-symbols";
    ModuleId["Scripts"] = "scripts";
    ModuleId["SharedMapSettings"] = "shared-map-settings";
    ModuleId["MapExport"] = "map-export";
    ModuleId["Documentation"] = "documentation";
    ModuleId["LayerExport"] = "layer-export";
})(ModuleId || (ModuleId = {}));
//# sourceMappingURL=ModuleId.js.map